module.exports = __webpack_public_path__ + "static/media/file_pdf.9a987d85.svg";